export class TabsSubtitleStyle {
  size = 'uk-h5';
  color = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  marginTop = 'uk-margin-remove-top';
  alignment = '';
  alignWithContent = false;

  static normalize(styles: Partial<TabsSubtitleStyle>): TabsSubtitleStyle {
    const pureStyles = new TabsSubtitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;
    pureStyles.alignWithContent = styles.alignWithContent ?? pureStyles.alignWithContent;

    return pureStyles;
  }
}
